import * as React from 'react';
export const TNSvg = React.forwardRef(function TNSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M8 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm1-4.732a2 2 0 1 0 0 3.464 1.75 1.75 0 1 1 0-3.464ZM9 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      }),
    ),
  );
});
TNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TN = {
  category: 'flag',
  colorable: false,
  name: 'TN',
  svg: TNSvg,
};
